import {
    useEffect, useMemo, useState,
} from 'react';
import { useSinglePortfolio } from '../context';
import { portfolioSelector, usePortfolioSelector } from '../../../../../../../domain/Portfolio';
import { contactSelector, useClientServiceSelector } from '../../../../../../../domain/ClientService';

export const useWithSumBar = () => {
    const { selectedProductSettings } = useSinglePortfolio() as any;
    const [totalValue, setTotalValue] = useState(0);

    const {
        dataRaw: dataRawPortfolio, isLoading: isPortfolioLoading, error: portfolioError,
    } = usePortfolioSelector(
        portfolioSelector,
    ) as any;

    const {
        data: contactDetails,
        isLoading: isLoadingContact,
    } = useClientServiceSelector(contactSelector) as any;

    useEffect(() => {
        setTotalValue(contactDetails?.details?.personalInformation?.affiliatedPensionFund
            ? selectedProductSettings?.maximumYearlyContributionWithPensionFund?.isDependantOnAffiliatedWithPensionFundTrue
            : selectedProductSettings?.maximumYearlyContributionWithPensionFund?.isDependantOnAffiliatedWithPensionFundFalse);
    }, [contactDetails, selectedProductSettings]);

    const currentValue = useMemo(() => {
        if (dataRawPortfolio?.CustomAttributes?.length) {
            return parseFloat(JSON.parse(dataRawPortfolio?.CustomAttributes ?? '{}')?.CurrentYearProgress ?? 0);
        }

        return 0;
    }, [dataRawPortfolio]);

    const restValue = useMemo(() => (totalValue - currentValue), [totalValue, currentValue]);

    return {
        currentValue,
        totalValue,
        restValue,
        isLoading: isPortfolioLoading || isLoadingContact,
        error: portfolioError,
    };
};
